import type { WindowWithIcbm } from "../index";
import { labradorKeyValuesMapper } from "../labrador";
import {
  samplingMatcher,
  type Matcher,
  getBucketingMatcherSelector,
} from "../matchers";
import { labradorBucketProvider } from "../bucketing";
import { fetchInstantConfig, getValue } from "./load";
import { override } from "./override";
import type { InstantConfigResponse, InstantConfigValue } from "./types";

export { type InstantConfigResponse, type InstantConfigValue };
export type InstantConfig = {
  config: Record<string, InstantConfigValue>;
  activeKeyValues: string[];
  activeLabradorKeyValues: string[];
};

export const getInstantConfig = async (
  app: string,
  container: WindowWithIcbm,
): Promise<InstantConfigResponse> => {
  const fetchedConfig = await fetchInstantConfig(container, app);
  return override(
    fetchedConfig,
    new URLSearchParams(container.location.search),
  );
};

export const parseConfig = (
  remoteConfig: InstantConfigResponse,
  matchers: Matcher[],
  container: WindowWithIcbm,
): InstantConfig => {
  const sampling = samplingMatcher(labradorBucketProvider(container));
  const labrador = labradorKeyValuesMapper(
    getValue(remoteConfig, matchers, "icLABradorGamKeyValues"),
  );

  const bucketingMatcherSelector = getBucketingMatcherSelector(container);

  const config = Object.keys(remoteConfig).reduce(
    (acc, key) => {
      acc[key] = getValue(
        remoteConfig,
        matchers,
        key,
        sampling,
        labrador,
        bucketingMatcherSelector,
      )!;
      return acc;
    },
    {} as Record<string, InstantConfigValue>,
  );

  return {
    config,
    activeKeyValues: labrador.getKeyValues(),
    activeLabradorKeyValues: labrador.getLabradorKeyValues(),
  };
};
